import { connect } from 'react-redux';
import mapTimelineActions from '../../../state/Timeline/MapTimeline/actions';

var mapStateToProps = function mapStateToProps() {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onMount: function onMount() {},
    toggleLayer: function toggleLayer(timelineLayerPeriodItem, timelineLayer, mapKey, layerRow, layers) {
      dispatch(mapTimelineActions.toggleTimelineLayer(timelineLayerPeriodItem, timelineLayer, mapKey, layerRow, layers));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps);